// extracted by mini-css-extract-plugin
export default {"container":"style_container__Pzyna","card":"style_card__kpDR3","row":"style_row__Z+Lfj","btnsRow":"style_btnsRow__11B+A"};